import React from "react";
import { map, get } from "lodash";
import { format } from "date-fns";
import { formatNewsDuration, getHignResImage } from "./helpers";
import { ellipsifyByChar } from "~/tools/strings/ellipsify";
import SharePopup from "~/views/Share/events";
import Badge from "~/elements/Tray/Badge";
import {
	getThumbnailImage,
	getLowQualityImage,
	trayHoverStyle
} from "../helpers";

import newsStore from "~/redux/news/store";
import connect from "~/tools/connect";
import { setExpandedDetails } from "~/redux/news/actions";
import { videoPlayHandler } from "~/components/ExpandedDetails/helper";

class NewsTrayItem extends React.Component {
	constructor(props) {
		super(props);
		this.el = React.createRef();
	}

	state={
		isHovered: false
	}

	handleClick = (evt, item, seriesData, curExpandId) => {
		const {innerWidth, innerHeight} = window;
		if(innerWidth > 1024 && innerHeight > 475) {
			this.updateExpandedDetails(item, seriesData, curExpandId);
		} else {
			if(seriesData && seriesData.length > 0){
				window.location.href = seriesData[0].gist.permalink;
			} else {
				videoPlayHandler(evt, item);
			}
		}
	}

	updateExpandedDetails = async (item, seriesData, curExpandId) => {
		await this.setState({
			isHovered: true
		});
		const trailerSrc = getHignResImage(this.props);
		const {title, description, permalink, contentType} = item.gist;
		const newsTrayId = this.props.newsTrayId;
		const storeNewsTrayId = newsStore.getState().newsTrayId;
		const seriesDatas = newsStore.getState().seriesDatas;
		const newSeriesDatas = {...seriesDatas};
		let id = item.gist.id;
		newSeriesDatas[id] = seriesData;
		
		if(item.gist.id === curExpandId && storeNewsTrayId === newsTrayId){
			id = ''
		}
		newsStore.dispatch(setExpandedDetails({
			trailerSrc,
			episodeTitle: title,
			episodeDesc: description,
			permalink,
			id,
			contentType,
			newsTrayId,
			seriesDatas: newSeriesDatas,
			video: item
		}));
	};

	handleHover = () => {
		this.setState({
			isHovered: true
		});
	}

	handleMouseLeave = () => {
		this.setState({
			isHovered: false
		});
	};

	handleShareToggleClick = event => {
		event.preventDefault();
		const shareOptions = {
			position: event.currentTarget.getBoundingClientRect(),
			data: this.props.item.gist
		};
		SharePopup.open(shareOptions);
	};

	clearSession() {
		//clearing the session for the autoplay to reinitiate to new set of videos
		window.sessionStorage.removeItem("rvid");
	}

	setActiveStyle = (gist, curExpandId) => {
		const siteColor = window.settings.brand.cta ? window.settings.brand.cta.primary.textColor : '';
		const storeNewsTrayId = newsStore.getState().newsTrayId;
		const parentNewsTrayId = this.props.newsTrayId;
		const curItemIsActived = gist.id === curExpandId && storeNewsTrayId === parentNewsTrayId;
		const activeStyle = {};
		if(this.state.isHovered || curItemIsActived){
			activeStyle.border = { 
				"border": `2px solid ${siteColor}` 
			}
		}
		if(curItemIsActived){
			activeStyle.triangle = {    
				"borderRight": `16px solid ${siteColor}`,
				"borderBottom": `16px solid ${siteColor}`
			}
		}
		return activeStyle;
	}

	render() {
		const { item, index } = this.props;
		const gist = item.gist || {};
		const isTrayGlow = get(window.settings, "brand.trayGlow.isTrayGlow");
		const trayGlowColor = get(window.settings, "brand.trayGlow.trayGlowColor");
		const hideVideoTitle = this.props.hideVideoTitle || false;
		const curExpandId = newsStore.getState().id;
		const activeStyle = this.setActiveStyle(gist, curExpandId);
		const duration = gist.runtime && formatNewsDuration(gist.runtime);
		const seriesData = item.seriesData || item.series;
		// console.log(item);
		
		return (
			<div
				className="news-tray-item-container"
				onMouseEnter={this.handleHover}
				onMouseLeave={this.handleMouseLeave}
				onClick={(evt) => this.handleClick(evt, item, seriesData, curExpandId)}
			>
				<div className="triangle" style={{ ...activeStyle.triangle }} />
				<div
					className="video-tray-item"
					ref={this.el}
					onFocus={this.handleFocus}
					style={{ ...activeStyle.border }}
				>
					<div className="image-and-details">
						{duration && <span className="news-duration-wrapper">
							{duration}
						</span>}
						<Badge item={item} thumbnailType={this.props.thumbnailType} />
						{isTrayGlow && (
							<div
								className="shadow-box"
								style={trayHoverStyle(trayGlowColor)}
							/>
						)}
						<div className="image">
							<img
								src={
									this.props.clickNext || !this.props.lazyLoad
										? getThumbnailImage(this.props)
										: getLowQualityImage(this.props)
								}
								alt={gist.title}
								className="lazy"
								data-src={getThumbnailImage(this.props)}
							/>
						</div>
					</div>
					{!hideVideoTitle && (
						<div className="title-container">
							<div className="title">
								{this.props.isEpisode && !this.props.noEpisodeNumber && (
									<span className="episode-number">{index}</span>
								)}{" "}
								{ellipsifyByChar(
									gist.title,
									50 - index.toString().length
								)}
							</div>
						</div>
					)}
				</div>
			</div>
		);
	}
}

connect(
	NewsTrayItem,
	state => ({
	}),
	newsStore
);

export default NewsTrayItem;
